import { checkRoles, getCurrentUser } from "helpers/Utils";

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'fa';
export const localeOptions = [
  { id: 'fa', name: 'Farsi - RTL', direction: 'rtl' },
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

// export const currentUser = {
//   id: 1,
//   title: 'فاطمه کاظمی زاده',
//   img: '/assets/img/profiles/l-1.jpg',
//   date: 'آخرین بازدید امروز 15:24',
//   role: UserRole.Admin,
// };

export const currentUser = getCurrentUser();
export const UserRole = {
  Admin: 'admin',
  Advisor: 'advisor',
  Manager: 'manager',
  Employee: 'employee',
  Storekeeper: 'storekeeper',
  Callcenter: 'callcenter',
  ManagerReporter: 'manager_reporter',
  Reporter: 'reporter',
};

export const panelRoot = '/app';
// export const userRoot = '/customer';

export const buyUrl = 'https://www.rtl-theme.com/?p=94491';
export const searchPath = `${panelRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.greenlime';
export const isDarkSwitchActive = false;
export const defaultDirection = 'rtl';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
